import { lazy } from 'react'

// Business Mode Pages
export const Dashboard = lazy(() => import('../../pages/Dashboard'))
export const Knowledge = lazy(() => import('../../pages/Knowledge'))
export const LiveMonitor = lazy(() => import('../../pages/LiveMonitor'))
export const Accounts = lazy(() => import('../../pages/Accounts'))
export const Routing = lazy(() => import('../../pages/Routing'))
export const Campaigns = lazy(() => import('../../pages/Campaigns'))
export const ContactLists = lazy(() => import('../../pages/ContactLists'))
export const OutboundPerformance = lazy(() => import('../../pages/OutboundPerformance'))
export const Compliance = lazy(() => import('../../pages/Compliance'))

// Consumer Mode Pages
export const ConsumerHome = lazy(() => import('../../pages/consumer'))
export const ConsumerWorkspace = lazy(() => import('../../pages/consumer/workspace/ConsumerWorkspace'))
export const MyInfo = lazy(() => import('../../pages/MyInfo'))
export const MyCalls = lazy(() => import('../../pages/consumer/MyCalls'))
export const MemoryVaultPage = lazy(() => import('../../components/MemoryVaultSettings'))
export const CalendarPage = lazy(() => import('../../pages/CalendarPage'))

// Shared Pages
export const SettingsPage = lazy(() => import('../../pages/Settings'))
export const AdminPage = lazy(() => import('../../pages/Admin'))

// Public Pages
export const LandingPage = lazy(() => import('../../pages/LandingPage'))
export const Waitlist = lazy(() => import('../../pages/Waitlist'))
export const About = lazy(() => import('../../pages/About'))
export const SharedCall = lazy(() => import('../../pages/SharedCall'))
export const EmbedCall = lazy(() => import('../../pages/EmbedCall'))

// Auth Pages
export const Login = lazy(() => import('../../pages/Login'))
export const PhoneVerify = lazy(() => import('../../pages/PhoneVerify'))
export const AccountRecovery = lazy(() => import('../../pages/AccountRecovery'))
export const ForgotAccess = lazy(() => import('../../pages/ForgotAccess'))
export const QrAuth = lazy(() => import('../../pages/QrAuth'))

// Franky Dashboard
export const FrankyDashboard = lazy(() => import('../../pages/franky/Dashboard'))
